import React from "react";

interface EnvironmentBannerProps {
  label?: string | null;
}

const EnvironmentBanner: React.FC<EnvironmentBannerProps> = ({ label }) => {
  const normalized = label?.trim();

  if (!normalized) {
    return null;
  }

  const uppercase = normalized.toUpperCase();
  const message = uppercase.includes("ENV") ? uppercase : `${uppercase} ENVIRONMENT`;

  return (
    <div
      className="bg-amber-500 text-white text-center text-xs font-semibold uppercase py-2 shadow-md"
      style={{ letterSpacing: "0.35em", position: "sticky", top: 0, zIndex: 9999 }}
    >
      {message}
    </div>
  );
};

export default EnvironmentBanner;
